import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./views/main-page/routes').then((mod) => mod.MAIN_PAGE_ROUTES),
  },
  {
    path: 'dashboard/:id',
    loadComponent: () =>
      import('./views/dashboard/dashboard.component').then(
        (m) => m.DashboardComponent,
      ),
    loadChildren: () =>
      import('./views/dashboard/components/tool-panel/routes').then(
        (mod) => mod.TOOLS_ROUTES,
      ),
  },
  {
    path: 'exam_open_access/:id',
    loadComponent: () =>
      import('./views/dashboard/dashboard.component').then(
        (m) => m.DashboardComponent,
      ),
    loadChildren: () =>
      import('./views/dashboard/components/tool-panel/routes').then(
        (mod) => mod.TOOLS_ROUTES,
      ),
  },
  {
    path: 'standalone_viewer/:id',
    loadComponent: () =>
      import(
        './shared/slide-viewer/standalone-viewer-window/standalone-viewer-window.component'
      ).then((m) => m.StandaloneViewerWindowComponent),
    loadChildren: () =>
      import('./shared/slide-viewer/standalone-viewer-window/routes').then(
        (mod) => mod.STANDALONE_ROUTES,
      ),
  },
  {
    path: 'exam_open_access/standalone_viewer/:id',
    loadComponent: () =>
      import(
        './shared/slide-viewer/standalone-viewer-window/standalone-viewer-window.component'
      ).then((m) => m.StandaloneViewerWindowComponent),
    loadChildren: () =>
      import('./shared/slide-viewer/standalone-viewer-window/routes').then(
        (mod) => mod.STANDALONE_ROUTES,
      ),
  },
  {
    path: 'exam_view/:code',
    loadComponent: () =>
      import('./views/lis-exam-page/lis-exam-page.component').then(
        (m) => m.LisExamPageComponent,
      ),
  },
  {
    path: 'image_view/:code',
    loadComponent: () =>
      import('./views/lis-slide-page/lis-slide-page.component').then(
        (m) => m.LisSlidePageComponent,
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./views/auth/routes').then((mod) => mod.AUTH_ROUTES),
  },
];
